import { useDispatch, useSelector } from 'react-redux';
import React, { ChangeEvent, useState } from 'react';

// local feature
import ConfirmationModal from './ConfirmationModal';
import slice, { selectors, thunks } from './slice';

import { Input } from './styled';

const { actions } = slice;

function EditWatchlist() {
  const { isCollectionLoading, modalVisible, selectedForModify } =
    useSelector(selectors);

  const dispatch = useDispatch();

  const [name, setName] = useState<string>(selectedForModify.name);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const onConfirmClick = () => {
    dispatch(
      thunks.editCompanyWatchlist({ name, id: selectedForModify.watchlist_id }),
    );
  };

  const onCancelClick = () => {
    dispatch(
      actions.handleSelectForModify({ modalType: 'none', selectedIndex: null }),
    );
  };

  const title = `Change watchlist name "${selectedForModify.name}"`;
  const isModalVisible = modalVisible === 'edit';

  return (
    <ConfirmationModal
      isVisible={isModalVisible}
      onCancel={onCancelClick}
      onConfirm={onConfirmClick}
      title={title}
    >
      <Input
        type="text"
        value={name}
        onChange={handleChange}
        disabled={isCollectionLoading}
        maxLength={25}
        size="large"
        suffix={`${name.length}/25`}
      />
    </ConfirmationModal>
  );
}

export default EditWatchlist;
